import * as yup from 'yup';

export const schema = yup.object({
  num_ncm: yup.string().required(),
  des_ncm: yup.string().trim().required(),
});
